import { Grid } from "@mui/material";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import Catchment from "./components/catchment/Catchment";
import CityHall from "./components/city-hall/CityHall";
import Confotur from "./components/confotur/Confotur";
import FlowProject from "./components/flow-project/FlowProject";
import Trust from "./components/trust/Trust";
import BuildingDeveloperOrPromotor from "./components/building-developer-promotor/BuildingDeveloperOrPromotor";
import PropertyStatusLand from "./components/status-land/StatusLand";
import Aprocovici from "./components/acoprovic/Aprocovici";
import useCountCatchMentTotal from "./hooks/useCountCatchMentTotal";
import { memo } from "react";

const ValidationsDocuments = () => {
  return (
    <Grid container my={2}>
      <Grid item xs="auto">
        <MxFormSubTitleAndDescription
          label="Validación del Proyecto"
          description="Declara la captación y documentos de validación del proyecto."
        />
      </Grid>
      <Catchment />
      <ProjectValidationSections />
    </Grid>
  );
};

export default ValidationsDocuments;

const ProjectValidationSections = memo(() => {
  const { totalUnits } = useCountCatchMentTotal();

  if (totalUnits < 79) {
    return <></>;
  }

  return (
    <>
      <Trust />
      <CityHall />
      <Confotur />
      <FlowProject />
      <BuildingDeveloperOrPromotor />
      <PropertyStatusLand />
      <Aprocovici />
    </>
  );
});
